import { Navigate, useLocation, useParams } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";

export default function JobDetailsPage() {
  usePageTitle("/sections/:sectionId/jobs/job-post/:jobPostId", "Sections | Jobs | Job Post Details");
  const location = useLocation();
  const { sectionId, jobPostId } = useParams();

  if (!sectionId || !jobPostId) return null;

  return <Navigate to={`${location.pathname}/details`} replace />;
}
